<!-- <div class="footer-nav-menu flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4"> -->
<div class="footer-nav-menu">
@if (currentMenuItem$ | async; as currentMenuItem) {

    <!-- Previous Page -->
    @if (!isSubmitted()) {
        <button
            mat-stroked-button
            id="form-nav-btn-back"
            class="form-nav-menu-btn"
            title="Go back to the previous page"
            [disabled]="!_navigationService.canNavigateBackward() || isBusy"
            (click)="_navigationService.navigateBackward()" test-id="back-button-id">
            <mat-icon [svgIcon]="'heroicons_outline:backward'"></mat-icon>
            <span class="nav-menu-hidden-text">Back</span>
        </button>
    }

    <!-- Close -->
    @if (_navigationService.canClose()) {
        <button
            mat-stroked-button
            id="form-nav-btn-back"
            class="form-nav-menu-btn"
            title="Close this application without saving"
            [disabled]="isBusy"
            (click)="_navigationService.closeApplication()">
            <!-- [routerLink]="['/form-vault']"" -->
            <mat-icon [svgIcon]="'mat_outline:exit_to_app'"></mat-icon>
            <span class="nav-menu-hidden-text">{{ _navigationService.closeText() }}</span>
        </button>
    }

    <div class="grow ml-0 inline-flex"></div>

    <save-and-print-button></save-and-print-button>
    <save-and-return-button></save-and-return-button>

    <!-- Save form -->
    <!-- [color]="'primary'" -->
    @if (_navigationService.canSave()) {
        <button
            mat-stroked-button
            id="form-nav-btn-save"
            class="form-nav-menu-btn"
            title="Save your application"
            [disabled]="isBusy"
            (click)="saveApplication()">
            <mat-icon [svgIcon]="'feather:save'"></mat-icon>
            <span class="nav-menu-hidden-text">Save</span>
        </button>
    }

    <!-- Next Page -->
    @if (_navigationService.canNavigateForward()) {
        <button
            mat-stroked-button
            id="form-nav-btn-next"
            class="form-nav-menu-btn"
            title="Continue to the next page"
            [disabled]="isBusy"
            (click)="_navigationService.navigateForward()">
            <mat-icon [svgIcon]="'heroicons_outline:forward'"></mat-icon>
            <span class="nav-menu-hidden-text">Next</span>
        </button>
    }

    <!-- Submit -->
    @if (_navigationService.canSubmit()) {
        <button
            mat-stroked-button
            color="primary"
            id="form-nav-btn-submit"
            class="form-nav-menu-btn"
            title="Submit your application"
            [disabled]="isBusy"
            (click)="submitApplication()">
            <mat-icon [svgIcon]="'feather:upload-cloud'"></mat-icon>
            <span class="nav-menu-submit-text">{{ submitText }}</span>
        </button>
    }
}
</div>
